import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';

const ColorPaletteGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.PALETTE]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.PALETTE, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const colors = Array.isArray(config.colors) ? config.colors : [];
  const setColors = (next) => updateConfig(TOOL_TYPES.PALETTE, { colors: next });

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Color Palette Generator</h2>

      <div className="space-y-3">
        {colors.map((c, idx) => (
          <div
            key={idx}
            className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 p-4"
          >
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
              <label className="block">
                <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Name</div>
                <input
                  type="text"
                  value={c.name}
                  onChange={(e) => {
                    const next = [...colors];
                    next[idx] = { ...next[idx], name: e.target.value };
                    setColors(next);
                  }}
                  className="w-full px-3 py-2 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                />
              </label>

              <label className="block">
                <div className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1">Hex</div>
                <input
                  type="text"
                  value={c.hex}
                  onChange={(e) => {
                    const next = [...colors];
                    next[idx] = { ...next[idx], hex: e.target.value };
                    setColors(next);
                  }}
                  className="w-full px-3 py-2 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                  placeholder="#3B82F6"
                />
              </label>

              <div className="flex items-center gap-2">
                <input
                  type="color"
                  value={c.hex}
                  onChange={(e) => {
                    const next = [...colors];
                    next[idx] = { ...next[idx], hex: e.target.value };
                    setColors(next);
                  }}
                  className="h-10 w-16 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900"
                  title="Pick color"
                />
                <button
                  onClick={() => setColors(colors.filter((_, i) => i !== idx))}
                  className="ml-auto text-xs px-3 py-2 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        ))}

        <button
          onClick={() => setColors([...colors, { name: `color${colors.length + 1}`, hex: '#111827' }])}
          className="w-full sm:w-auto text-sm px-4 py-2 rounded-md bg-gradient-primary hover:opacity-90 text-white font-semibold"
        >
          Add color
        </button>
      </div>
    </div>
  );
};

export default ColorPaletteGenerator;

